import { ChartOptions } from 'chart.js';

export const comboChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    title: {
        display: true,
        text: 'Estimated Plays and Spent Balance over Time'
    },
    legend: {
        display: true,
        position: 'top'
    },
    plugins: {
        datalabels: {
            display: false
        }
    },
    tooltips: {
        enabled: true,
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleFontSize: 14,
        bodyFontSize: 13,
        bodySpacing: 4,
        xPadding: 12,
        yPadding: 12,
        cornerRadius: 4
    },
    scales: {
        xAxes: [
            {
                gridLines: {
                    display: true
                }
            }
        ],
        yAxes: [
            {
                id: 'y-axis-0',
                type: 'linear',
                position: 'left',
                scaleLabel: {
                    display: true,
                    labelString: 'Plays'
                },
                ticks: {
                    beginAtZero: true
                }
            },
            {
                id: 'y-axis-1',
                type: 'linear',
                position: 'right',
                scaleLabel: {
                    display: true,
                    labelString: 'Spent'
                },
                gridLines: {
                    drawOnChartArea: false
                },
                ticks: {
                    beginAtZero: true
                }
            }
        ]
    }
};

export const pieChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    title: {
        display: true,
        text: 'Plays Distribution across Channels',
        position: 'top',
        fontSize: 16,
        padding: 10
    },
    legend: {
        position: 'bottom',
        align: 'center'
    },
    plugins: {
        datalabels: {
            display: true,
            color: '#313131ff',
            font: {
                size: 12
            },
            formatter: (value, context) => {
                const dataArray = context.chart.data.datasets[0].data as number[];
                const total = dataArray.reduce((acc, val) => acc + val, 0);
                const percentage = ((Number(value) / total) * 100).toFixed(1);
                return percentage + '%';
            }
        }
    },
    tooltips: {
        enabled: true,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleFontSize: 14,
        bodyFontSize: 13,
        bodySpacing: 4,
        xPadding: 12,
        yPadding: 12,
        cornerRadius: 4,
        displayColors: true,
        callbacks: {
            label: (tooltipItem, data) => {
                const label = data.labels[tooltipItem.index] || '';
                const value = data.datasets[0].data[tooltipItem.index];

                const dataArray = data.datasets[0].data as number[];
                const total = dataArray.reduce((acc, val) => acc + val, 0);
                const percentage = ((Number(value) / total) * 100).toFixed(1);

                return label + ': ' + value + ' (' + percentage + '%)';
            }
        }
    }
};

export const COLOR_PALETTE = [
    'rgba(255, 193, 7, 0.8)',
    'rgba(100, 181, 246, 0.8)',
    'rgba(76, 175, 80, 0.8)',
    'rgba(255, 235, 59, 0.8)',
    'rgba(3, 169, 244, 0.8)',
    'rgba(233, 30, 99, 0.8)',
    'rgba(156, 39, 176, 0.8)',
    'rgba(103, 58, 183, 0.8)',
    'rgba(63, 81, 181, 0.8)',
    'rgba(33, 150, 243, 0.8)',
    'rgba(0, 188, 212, 0.8)',
    'rgba(0, 150, 136, 0.8)',
    'rgba(139, 195, 74, 0.8)',
    'rgba(205, 220, 57, 0.8)',
    'rgba(255, 152, 0, 0.8)',
    'rgba(255, 87, 34, 0.8)',
    'rgba(121, 85, 72, 0.8)',
    'rgba(158, 158, 158, 0.8)',
    'rgba(96, 125, 139, 0.8)',
    'rgba(244, 67, 54, 0.8)'
];

export function generateColors(count: number): string[] {
    const colors: string[] = [];
    for (let i = 0; i < count; i++) {
        colors.push(COLOR_PALETTE[i % COLOR_PALETTE.length]);
    }
    return colors;
}
